(function () {

    'use strict';
    angular.module('app')
        .controller('requestPasswordController', ['$scope', '$location', '$routeParams', 'loginService', 'stateService', requestPasswordController]
           );

    function requestPasswordController($scope, $location, $routeParams, loginService, stateService) {
        //$scope.model = stateService.model;
        $scope.model = {};

        $scope.submit = function () {
            $scope.model.submitted = true;
            if (!$scope.requestPasswordForm.$valid) {
                return;
            }

            $scope.model.working = true;

            loginService.requestPassword($scope.model.email, $routeParams.ct)
                .then(function () {
                    $scope.model.complete = true;
                    $scope.model.success = true;
                },
                    function () {
                        $scope.model.working = false;
                        $scope.model.complete = true;
                        $scope.model.success = false;
                    });
        };
    }
})();